/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2018 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.chosen = {
    attach: function (context) {
      // Chosen
      $('.chosen', context).chosen({ width: '100%' });
    }
  };

  // Use behaviors with context variable.
  Drupal.behaviors.tooltipPopup = {
    attach: function (context) {

      $('[data-toggle="tooltip"]').tooltip({
        tooltipClass: "custom-tooltip-styling",
        disabled: true,
        close: function ( event, ui ) {
          $(this).tooltip('disable');
        }
      });

      $('[data-toggle="tooltip"]').on('mouseover click', function () {
        $(this).tooltip('enable').tooltip('open');
      });

    }
  };
  
})(jQuery);
